<template>
  <main
    id="main"
    role="main"
    :class="className"
  >
    <slot />

    <!-- gap before footer coz of footer waves -->
    <div
      v-if="(isDesktop && includeFooterGap) || BrowserService.isMobileWebview()"
      class="py-6 lg:py-7 xl:py-8"
    />
  </main>
</template>

<script setup>
import { computed } from 'vue'

import BrowserService from '@/services/browserService'

const props = defineProps({
  backgroundColor: {
    type: String,
    default: 'bg-primary-200',
    validator: (value) => value.includes('bg-'),
  },

  includeFooterGap: {
    type: Boolean,
    default: true,
  },
  includeHeaderGap: {
    type: Boolean,
    default: true,
  },
})

const className = computed(() => {
  return [props.includeHeaderGap ? 'flex-grow-1 pt-2 sm:pt-5' : '', props.backgroundColor].join(' ')
})

const isDesktop = computed(() => {
  return BrowserService.isDesktop()
})
</script>
